// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2fRZ6","insightsList":"newBusinessInsightsMenu_insightsList__KWmaW","active":"newBusinessInsightsMenu_active__3XCdR"};